<script setup lang="ts">
import { Feature } from "../classes/feature";
import { defineProps, withDefaults } from "vue";
import { Product } from "../classes/product";

interface Props {
  product: Product;
  feature: Feature;
}

const props = withDefaults(defineProps<Props>(), {
  productGroup: null,
  feature: null,
});
</script>

<template>
  <div class="table-row">
    <div class="table-row-left">
      <div v-html="props.feature.value"></div>
      <div
        class="text-small"
        v-if="props.feature.subValue"
        v-html="props.feature.subValue || props.feature.description"
      ></div>
    </div>
    <div class="table-row-right">
      <div
        v-if="
          typeof props.product.getFeatureValue(props.feature.id)?.value ===
          'string'
        "
        v-html="props.product.getFeatureValue(props.feature.id)?.value"
      ></div>
      <div
        v-else
        :class="{
          'agila-icon-check':
            props.product.getFeatureValue(props.feature.id)?.value === true,
          'agila-icon-skip':
            props.product.getFeatureValue(props.feature.id)?.value === false,
        }"
      ></div>
      <div
        class="text-small"
        v-if="props.product.getFeatureValue(props.feature.id)?.subValue"
        v-html="
          props.product.getFeatureValue(props.feature.id)?.subValue ||
          props.product.getFeatureValue(props.feature.id)?.description
        "
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
